const MIN_SUPPORTED_WIDTH = 600

// Dashboards are for desktop and iPad, not phones. The window has to be wide enough everywhere. In the
// native app the device's screen also has to be tablet-sized, because the window can't tell: a phone in
// landscape is wide, and the on-screen keyboard shrinks an iPad's web view. An iPad's short side is 744+,
// a phone's at most about 430.
export const getIsDashboardsSupported = ({
  isNativeApp,
  windowWidth,
  deviceScreenWidth,
  deviceScreenHeight,
}: {
  isNativeApp: boolean
  windowWidth: number
  deviceScreenWidth: number
  deviceScreenHeight: number
}): boolean => {
  if (windowWidth < MIN_SUPPORTED_WIDTH) return false

  if (!isNativeApp) return true

  return Math.min(deviceScreenWidth, deviceScreenHeight) >= MIN_SUPPORTED_WIDTH
}
